const settings = {
    APP_URL: process.env.VUE_APP_URL,
    APP_SERVICE_URL: process.env.VUE_APP_SERVICE_URL,
}

export default settings
